export const SURVEY_FREQUENCY = {
  WEEKLY: 'weekly',
  DAILY: 'daily'
};
